import {
  Gender,
  MedicineTypeDropdown,
  MRSA,
  UserResponse,
  UserStatus,
} from "./enums";

export interface IUserForms {
  label: string;
  key: string;
  type: string;
  required: boolean;
  disable: boolean;
  className: string;
  max?: number;
  options?: any;
}

export interface IForms {
  id: string;
  image: File;
  imageData: string;
  description: string;
  patientFirstName: string;
  patientMiddleName: string;
  patientLastName: string;
  dob: string;
  age: number;
  gender: string;
  address: string;
  mrn: string;
  isATSI: string;
  doctorName: string;
  wardName: string;
  diagnosis: string;
  ethinicity: string;
  isInterpreterRequired: string;
  isMRSA: string;
  allergies: string;
  remarks: string;
}

export const ctInitForm = {
  id: "",
  image: null,
  imageData: "",
  templateDescription: "",
  patientFirstName: "",
  patientMiddleName: "",
  patientLastName: "",
  dob: "",
  age: 0,
  gender: "",
  address: "",
  mrn: "",
  isATSI: "",
  doctorName: "",
  wardName: "",
  diagnosis: "",
  ethinicity: "",
  isInterpreterRequired: "",
  isMRSA: "",
  allergies: "",
  remarks: "",
};

export const ctFormFields = {
  description: {
    label: "Template Description",
    key: "templateDescription",
    type: "text",
    required: true,
    disable: false,
    className: "",
    max: 250,
  },
  info: [
    {
      label: "First Name",
      key: "patientFirstName",
      type: "text",
      required: true,
      disable: false,
      className: "",
      max: 50,
    },
    {
      label: "Middle Name",
      key: "patientMiddleName",
      type: "text",
      required: false,
      disable: false,
      className: "",
      max: 50,
    },
    {
      label: "Last Name",
      key: "patientLastName",
      type: "text",
      required: true,
      disable: false,
      className: "",
      max: 50,
    },
    {
      label: "D.O.B.",
      key: "dob",
      type: "date",
      required: true,
      disable: false,
      className: "",
    },
    {
      label: "Age",
      key: "age",
      type: "text",
      required: false,
      disable: true,
      className: "",
    },
    {
      label: "Sex",
      key: "gender",
      type: "select",
      required: true,
      disable: false,
      className: "",
      options: [Gender.MALE, Gender.FEMALE, Gender.OTHER],
    },
    {
      label: "Address",
      key: "address",
      type: "text",
      required: false,
      disable: false,
      className: "",
      size: 12,
      max: 250,
    },
  ],
  details: [
    {
      label: "MRN",
      key: "mrn",
      type: "text",
      required: true,
      disable: false,
      className: "",
    },
    {
      label: "Aboriginal and Torres Strait Islander",
      key: "isATSI",
      type: "select",
      required: true,
      disable: false,
      className: "",
      options: [UserResponse.YES, UserResponse.NO],
    },
    {
      label: "Doctor's Name",
      key: "doctorName",
      type: "text",
      required: true,
      disable: false,
      className: "",
      max: 100,
    },
    {
      label: "Ward Name",
      key: "wardName",
      type: "text",
      required: true,
      disable: false,
      className: "",
      max: 100,
    },
    {
      label: "Admission Diagnosis",
      key: "diagnosis",
      type: "text",
      required: true,
      disable: false,
      className: "",
      max: 500,
    },
    {
      label: "Ethnicity",
      key: "ethinicity",
      type: "",
      required: true,
      disable: false,
      className: "",

      max: 25,
    },
    {
      label: "Interpreter Required",
      key: "isInterpreterRequired",
      type: "radio",
      required: true,
      disable: false,
      className: "",
      options: [UserResponse.YES, UserResponse.NO],
    },
  ],
  alerts: [
    {
      label: "MRSA",
      key: "isMRSA",
      type: "select",
      required: true,
      disable: false,
      className: "",
      options: [MRSA.POSITIVE, MRSA.NEGATIVE],
    },
    {
      label: "Allergies",
      key: "allergies",
      type: "textarea",
      required: true,
      disable: false,
      className: "",
      max: 500,
    },
    {
      label: "Remarks",
      key: "remarks",
      type: "textarea",
      required: false,
      disable: false,
      className: "",
      max: 500,
    },
  ],
};

export const medicationInitForm = {
  templateId: "",
  medicineType: "",
  offset: "",
  medicineName: "",
  route: "",
  dose: "",
  maxPRN: "",
  frequencyId: "",
  remarks: "",
  indication: "",
  prescribedBy: "",
  interval: [],
};

export const medicationFormFields = [
  {
    label: "Medicine Type",
    key: "medicineType",
    type: "select",
    required: true,
    disable: false,
    className: "",
    max: 20,
    options: [...MedicineTypeDropdown],
  },
  {
    label: "Offset",
    key: "offset",
    type: "offset",
    required: true,
    disable: false,
    className: "",
    max: 50,
  },
  {
    label: "Medicine Name",
    key: "medicineName",
    type: "text",
    required: true,
    disable: false,
    className: "",
    max: 250,
  },
  {
    label: "Route",
    key: "route",
    type: "text",
    required: true,
    disable: false,
    className: "",
    max: 10,
  },
  {
    label: "Dose",
    key: "dose",
    type: "text",
    required: true,
    disable: false,
    className: "",
    max: 10,
  },
  {
    label: "Max PRN Dose/24hrs",
    key: "maxPRN",
    type: "text",
    required: true,
    disable: false,
    className: "",
    max: 10,
  },
  {
    label: "Frequency",
    key: "frequencyId",
    type: "select",
    required: true,
    disable: false,
    className: "",
    max: 10,
    options: [],
  },
  {
    label: "Dose Remarks",
    key: "remarks",
    type: "text",
    required: false,
    disable: false,
    className: "",
    max: 500,
  },
  {
    label: "time",
    key: "time",
    type: "time",
    required: true,
    disable: false,
    className: "",
    max: 50,
  },
  {
    label: "Indication",
    key: "indication",
    type: "text",
    required: true,
    disable: false,
    className: "",
    max: 200,
  },
  {
    label: "Prescribed By",
    key: "prescribedBy",
    type: "text",
    required: true,
    disable: false,
    className: "",
    max: 50,
  },
];

export const manageRolePopupField = [
  {
    label: "Student/Tutor Code",
    key: "code",
    type: "text",
    required: false,
    disable: true,
    className: "",
    max: 20,
  },
  {
    label: "Role Name",
    key: "roleId",
    type: "select",
    required: false,
    disable: false,
    className: "",
    max: 50,
    options: [],
  },
  {
    label: "Cohort Name",
    key: "cohortId",
    type: "select",
    required: false,
    disable: false,
    className: "",
    max: 50,
    options: [],
  },
  {
    label: "Status",
    key: "statusId",
    type: "select",
    required: false,
    disable: false,
    className: "",
    max: 50,
    options: [...UserStatus],
  },
];
